import styled from "styled-components";

export const ModalTitle = styled.p`
  margin-bottom: 0;
  font-family: medium-pro, sans-serif;
`;
